/* jshint esversion: 6 */
import React from 'react';
import * as _ from "underscore";
import { Link } from 'react-router-dom';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import MinimalModal from 'app/components/Modals/MinimalModal.jsx';
import ToggleControl from 'app/components/common/ToggleControl.jsx';
import Modal from 'app/components/common/Modal.jsx';
import CompactSubscriptionModal from 'app/components/Subscription/CompactSubscriptionModal.jsx';

class WelcomeBack extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            unpause: true
        };

        this.unpauseAccount = this.unpauseAccount.bind(this);

    }

    componentDidMount() {
        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Welcome Back Modal - View',
                event_data: {
                    version: this.state.version
                }
            });
        }
    }

    unpauseAccount() {

        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Welcome Back Modal - Unpaused'
            });
        }

        let user = Object.assign({}, this.props.user.detail),
            constants = this.props.app.config.constants;

        if (this.state.unpause) {
            user.pauseButton = constants.PUB_PAUSE_OFF;
            this.props.updateUser(user);
        } else {
            user.pauseButton = constants.PUB_PAUSE_OFF;
            user.specialUnpause = 1;
            this.props.updateUser(user);
        }

    }

    render() {
        let welcomeContent = null,
            closeAction = (e) => {
                e.preventDefault();
                this.setState({
                    unpause: false
                }, () => {
                    this.unpauseAccount();
                    this.props.dismissModal();
                });
            };


        welcomeContent = (
            <CompactSubscriptionModal
                {...this.props}
                headline={"Post without limits"}
                mainCopy={"Welcome back to dlvr.it! Your 14 day Pro trial is active."}
                confirmLabel={"Start posting"}
                confirmAction={(e) => {
                    e.preventDefault();
                    this.unpauseAccount();
                    this.props.dismissModal();
                }}
                cancelLabel={"Stay paused"}
                cancelAction={closeAction}
                closeAction={closeAction}
                context="welcomeback"/>
        );




        return (
            <Modal
                content={welcomeContent}
                boxClass={"trial-ended-box"}
                mainClass={"trial-ended-content"}/>
        );

    }
}

WelcomeBack.displayName = "WelcomeBack";

export default ComponentWithContext(WelcomeBack);
